import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('FooterController', FooterController);

    function FooterController() {
        var vm = this;

        init();

        function init() {
            vm.currentDate = new Date();
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/footer/footer.controller.ts